module.exports = __webpack_public_path__ + "static/final-phone-rotated-000b43ef226b0f93dcacd57a9c27f3de.gif";